const urlToId = (url = '') => {
  const idRegExp = new RegExp('/[a-z0-9]+/[_a-z]+/([0-9]+)');

  const results = idRegExp.exec(url);
  if (results && results.length >= 2) return parseInt(results[1], 10);

  return '';
};

export default urlToId;
